<template>
    <ul class="toolbar">
        <li>
            <a href="http://m.me/inspirationphotographers?ref=member_dashboard"
               target="_blank"
               :alt="$t('Contact us through Messenger')"
            >
                <i class="fab fa-facebook-messenger"></i>
            </a>
        </li>
        <li>
            <router-link to="/payments" :alt="$t('Payments')">
                <i class="material-icons notranslate">payment</i>
            </router-link>
        </li>
        <li>
            <a :href="$t('terms_of_use_url')"
               target="_blank"
               :alt="$t('Terms of use')"
            >
                <i class="material-icons notranslate">history_edu</i>
            </a>
        </li>
        <li class="sign_out">
            <a href="#" :alt="$t('Sign out')" @click.prevent="signOut">
                <i class="material-icons notranslate">exit_to_app</i>
            </a>
        </li>
    </ul>
</template>

<script>
import { siteUrl } from '../utils/api'
export default {
  name: 'ToolBar',
  computed: {
    profilePicture: function () {
      return this.$store.state.user.profile_picture
    }
  },
  methods: {
    signOut: function () {
      localStorage.removeItem('token')
      window.location.href = `${siteUrl}/wp-login.php?action=logout`
    }
  }
}
</script>

<style lang="scss">
    .toolbar {
        float: right;
        height: 48px;
        margin: 0;
        list-style: none;

        li {
            float: left;
            padding: 12px;
            width: 48px;
            height: 48px;
            a {
                text-decoration: none;
                position: relative;
                color: rgba(0,0,0,0.38);
                &:hover {
                    color: rgba(0,0,0,0.87);
                }
                &:before {
                    position: absolute;
                    top: 24px;
                    right: 50%;
                    transform: translateX(50%);
                    content: attr(alt);
                    white-space: nowrap;
                    text-align: right;
                    background: #e0e0e0;
                    color: rgba(0,0,0,0.87);
                    padding: 6px 8px;
                    border-radius: 4px;
                    font-size: 16px;
                    visibility: hidden;
                }
                &:hover:before {
                    visibility: visible;
                }
                i {
                    font-size: 24px;
                    line-height: 24px;
                }
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
        }
    }
</style>

<i18n>
    {
        "en": {
            "Contact us through Messenger": "Contact us through Messenger",
            "Payments": "Payments",
            "Sign out": "Sign out",
            "My account": "My account",
            "Terms of use": "Terms of use",
            "terms_of_use_url": "http://pages.inspirationphotographers.com/terms-of-use"
        },
        "pt": {
            "Contact us through Messenger": "Fale conosco pelo Messenger",
            "Payments": "Pagamentos",
            "Sign out": "Sair",
            "My account": "Meu cadastro",
            "Terms of use": "Termos de uso",
            "terms_of_use_url": "http://pages.inspirationphotographers.com/pagina-de-termos-de-uso"
        }
    }
</i18n>
